import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import type { SecondSignatureCodeTarget } from './useRequestSecondSignatureCode'

export type ResendSecondSignatureCodeResponse =
  | {
      status: 'sent'
      maskedEmail: string
      expiresAt: string
      resendAvailableAt: string
    }
  | {
      status: 'cooldown'
      resendAvailableAt: string
    }

const useResendSecondSignatureCode = () => {
  const mutation = useMutation(
    ({ signerId, subjectId }: SecondSignatureCodeTarget) =>
      postJSON({
        url: '/emar/second-signature-codes/resend-code',
        json: { signerId, subjectId }
      })
  )

  return {
    resendCode: mutation.mutateAsync as (
      target: SecondSignatureCodeTarget
    ) => Promise<ResendSecondSignatureCodeResponse>,
    isLoading: mutation.isLoading
  }
}

export default useResendSecondSignatureCode
